import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingCart } from 'lucide-react';
const names = ['Mariana', 'Lucas', 'Florencia', 'Martín', 'Sofía', 'Diego', 'Valentina', 'Agustín', 'Camila', 'Juan', 'Lucía', 'Matías', 'Julieta', 'Nicolás'];
const cities = ['Mendoza', 'Buenos Aires', 'Córdoba', 'Rosario', 'Santa Fe', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Neuquén', 'San Juan', 'Paraná'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 mins
      setCurrentPurchase({
        name: randomName,
        city: randomCity,
        time: `hace ${randomTime} min`
      });
      setIsVisible(true);
      // Auto dismiss after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 5000);
    // Recurring interval (every 30 seconds)
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-274">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border border-[#0284C7]/10 p-4 pr-10 max-w-sm flex items-start gap-3" data-id="element-275">
          <div className="bg-[#0284C7]/10 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-276">
            <ShoppingCart className="w-5 h-5 text-[#0284C7]" data-id="element-277" />
          </div>

          <div data-id="element-278">
            <p className="text-sm text-gray-800 font-medium" data-id="element-279">
              <span className="font-bold text-[#0284C7]" data-id="element-280">
                {currentPurchase.name}
              </span>{' '}
              de {currentPurchase.city} acaba de comprar HOCKEY 360
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-281">{currentPurchase.time}</p>
          </div>

          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-282">
            <X className="w-4 h-4" data-id="element-283" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}